import { BUCKET_DROPPABLE_CONTAINER_ID } from "@miplatform/constants";
import { useDroppable } from "@dnd-kit/core";
import { Box } from "@mui/material";

export function Buckets({ children }) {
  const { setNodeRef } = useDroppable({ id: BUCKET_DROPPABLE_CONTAINER_ID });

  return (
    <Box overflow="hidden" width="100%" ref={setNodeRef}>
      {children}
    </Box>
  );
}
